module.exports = __webpack_public_path__ + "img/hw-01.32173bcd.jpeg";